import React from "react";
import {
  ThemeProvider,
  createGlobalStyle,
  StyleSheetManager,
} from "styled-components";

import theme from "../theme";
import { ToastGlobalStyle } from "../components/Toast/styled";

export const GlobalStyle = createGlobalStyle`
  body {
    font-family: ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol";
  }
`;

const Theme = ({ children }) => {
  // only used for testing
  // @ts-ignore
  return (
    <StyleSheetManager enableVendorPrefixes>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </StyleSheetManager>
  );
};

const withTheme = <T extends object>(Component: React.FunctionComponent<T>) => {
  const WithThemeComp = (props: T) => {
    return (
      // @ts-ignore
      <StyleSheetManager enableVendorPrefixes>
        <ThemeProvider theme={theme}>
          {/* @ts-ignore */}
          <GlobalStyle />
          {/* @ts-ignore */}
          <ToastGlobalStyle />
          <Component {...props} />
        </ThemeProvider>
      </StyleSheetManager>
    );
  };
  return WithThemeComp;
};

export default withTheme;
export { Theme };
